/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getRepo.defs.js'
export * as $defs from './getRepo.defs.js'
